<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <div class="detailed-view-side-heading-name">Website Theme Builder</div>
        <span class="close-detailed-view" (click)="websiteBuilderService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="m-t-md">
            <form #form="ngForm" submittable autocomplete="off">
                <div>
                    <div class="detailed-view-navigation btn-group btn-group-justified">
                        <div class="col-xs-4 no-padding btn"
                             [ngStyle]="{'background-color': navPosition == 'settings' ? '#ebebeb' : ''}">
                            <div class="button-section" (click)="navPosition = 'settings';">Settings</div>
                        </div>
                        <div class="col-xs-4 no-padding btn"
                             [ngStyle]="{'background-color': navPosition == 'homepage' ? '#ebebeb' : ''}">
                            <div class="button-section" (click)="navPosition = 'homepage';">Homepage</div>
                        </div>
                        <div class="col-xs-4 no-padding btn"
                             [ngStyle]="{'background-color': navPosition == 'publish' ? '#ebebeb' : ''}">
                            <div class="button-section" (click)="navPosition = 'publish';">Publish</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="navPosition == 'settings'">

                    <!-- Theme select -->
                    <div class="row m-b-sm m-t-sm">
                        <div class="col-md-5">
                            <label>Select Color</label>
                        </div>
                        <div class="col-md-7"></div>
                    </div>

                    <div *ngFor="let color of themeColors" class="row theme m-b-sm">
                        <div class="col-md-5">
                            <label>{{color.name}}</label>
                        </div>
                        <div class="col-md-7">
                            <color-picker [(color)]="websiteBuilderService.data.data.themeColors[color.key]" (colorChange)="themeChanged()"></color-picker>
                        </div>
                    </div>

                    <!--Logo -->
                    <div class="row m-b-sm">
                        <div class="col-md-5">
                            <label>Upload Logo</label>
                        </div>
                        <div class="col-md-7 detailed-view-image">
                            <input type="file"
                                   name="logo"
                                   accept=".gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff"
                                   id="add-logo-img"
                                   (change)="addImage($event, 'logo')"
                                   [disabled]="disabledFileInput">
                            <label for="add-logo-img" class="mtv-primary-color">
                                <div class="placeholder" *ngIf="!websiteBuilderService.data.data.websiteLogo"></div>
                                <div class="add-logo-img-container" *ngIf="websiteBuilderService.data.data.websiteLogo">
                                    <img [src]="websiteBuilderService.data.data.websiteLogo">
                                </div>
                            </label>
                        </div>
                        <spinner [spinnerShow]="disabledFileInput"></spinner>
                    </div>
                </div>
                <div *ngIf="navPosition == 'homepage'">
                    <ul [dragula]='"bag-websiteParts"'
                        [dragulaModel]='websiteBuilderService.data.data.pageKeys'
                        class="website-parts">
                        <ng-container
                            *ngFor="let pageKey of websiteBuilderService.data.data.pageKeys; let index = index;">
                            <li *ngIf="websiteBuilderService.data.data.websitePages[pageKey] as item"
                                class="item-part list-unstyled"
                                [ngClass]="{'welcome-slider-li' : (pageKey === websitePage.welcome)}">
                                <div class="img-draggable"
                                     style="background-image: url('../../../../assets/img/draggable.png')"></div>
                                <div class="website-part-element settings-amenities-slider-container"
                                     [ngClass]="{'mtv-primary-border' : item.isOpened}"
                                     (mouseenter)="pageKey === websitePage.welcome && onMouseOver($event)">
                                    <div class="col-md-8" style="display: flex; margin-top: 2px;">
                                        <div class="plus-minus-icon-margin" *ngIf="item.isOpened">
                                            <i class="fa fa-2x fa-minus-circle mtv-primary-color"
                                               (click)="item.isOpened = false"></i>
                                        </div>
                                        <div class="plus-minus-icon-margin" *ngIf="!item.isOpened">
                                            <i class="fa fa-2x fa-plus-circle" (click)="item.isOpened = true"></i>
                                        </div>
                                        <span>{{item.name}}</span>
                                    </div>
                                    <div class="col-md-4" style="text-align: right;">
                                        <mat-slide-toggle [disabled]="item.isDisable"
                                                          name="{{index}}isPresent"
                                                          [(ngModel)]="item.isPresent">
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                                <div class="website-part-open-element" *ngIf="item.isOpened">
                                    <div *ngIf="pageKey === websitePage.welcome">
                                        <wb-edit-top-banner [pageData]="item"></wb-edit-top-banner>
                                    </div>

                                    <wb-edit-about *ngIf="pageKey === websitePage.about || pageKey === websitePage.welcomeMessage"
                                                   [pageData]="item">
                                    </wb-edit-about>

                                    <div *ngIf="item.name == 'Gallery'">
                                        <!--  Type   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-3">
                                                <label>Type</label>
                                            </div>
                                            <div class="col-md-9">
                                                <mat-radio-group name="galleryType"
                                                                 class="three-radio-buttons"
                                                                 [(ngModel)]="item.type">
                                                    <mat-radio-button value="grid">
                                                        Grid
                                                    </mat-radio-button>
                                                    <mat-radio-button value="parallax">
                                                        Parallax
                                                    </mat-radio-button>
                                                    <mat-radio-button value="sidebar">
                                                        Sidebar
                                                    </mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                        </div>

                                        <!--  Images  -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4">
                                                <label>Images</label>
                                            </div>
                                            <div class="col-md-8">
                                                <div fileDrop
                                                     class="drop-zone"
                                                     [ngClass]="{'file-is-over my-drop-zone': item.fileIsOver}"
                                                     [options]="options"
                                                     (drop)="onFileDrop($event, pageKey)"
                                                     (fileOver)="fileOver($event, index)">
                                                    Drag and Drop images or
                                                    <span class="mtv-primary-color clickable-text"
                                                          (click)="clickFileInput(index)">
                                                    browse
                                                </span>
                                                </div>
                                                <input id="fileInput{{index}}"
                                                       name="fileInput{{index}}"
                                                       type="file"
                                                       class="hidden"
                                                       (change)="onFileInput($event, pageKey)">
                                            </div>
                                        </div>
                                        <div *ngFor="let image of item.galleryImages; let imageIndex = index;">
                                            <div class="row m-b-sm">
                                                <div class="col-md-4 gallery-image-uploaded">
                                                    <div class="image-wrapper">
                                                        <img [src]="image.imageUrl"/>
                                                        <div class="remove-image">
                                                            <i class="fa fa-times-circle fa-2x"
                                                               aria-hidden="true"
                                                               (click)="removeImage($event, 'pages', item, imageIndex)">
                                                            </i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-8">
                                                <textarea class="form-control caption-description-min-height"
                                                          name="galleryImageCaption{{imageIndex}}"
                                                          resizable="false"
                                                          placeholder="Caption Text..."
                                                          [(ngModel)]="image.captionText"
                                                          maxlength="65535">
                                                </textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="pageKey === websitePage.buildingFeatures">
                                        <!--  Type   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-3">
                                                <label>Type</label>
                                            </div>
                                            <div class="col-md-9">
                                                <mat-radio-group name="featuresType"
                                                                 class="three-radio-buttons"
                                                                 [(ngModel)]="item.type">
                                                    <mat-radio-button value="list">
                                                        List
                                                    </mat-radio-button>
                                                    <mat-radio-button value="tiles">
                                                        Tiles
                                                    </mat-radio-button>
                                                    <mat-radio-button value="checkerboard">
                                                        Checkerboard
                                                    </mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                        </div>

                                        <!--  Images  -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4">
                                                <label>Images</label>
                                            </div>
                                            <div class="col-md-8">
                                                <div fileDrop
                                                     class="drop-zone"
                                                     [ngClass]="{'file-is-over my-drop-zone': item.fileIsOver}"
                                                     [options]="options"
                                                     (drop)="onFileDrop($event, pageKey)"
                                                     (fileOver)="fileOver($event, index)">
                                                    Drag and Drop images or
                                                    <span class="mtv-primary-color clickable-text"
                                                          (click)="clickFileInput(index)">
                                                    browse
                                                </span>
                                                </div>
                                                <input id="fileInput{{index}}"
                                                       name="fileInput{{index}}"
                                                       type="file"
                                                       class="hidden"
                                                       (change)="onFileInput($event, pageKey)">
                                            </div>
                                        </div>
                                        <div *ngFor="let image of item.buildingFeaturesImages; let imageIndex = index;">
                                            <div class="row m-b-sm">
                                                <div class="col-md-4">
                                                    <div class="image-wrapper">
                                                        <img [src]="image.imageUrl"/>
                                                        <div class="remove-image">
                                                            <i class="fa fa-times-circle fa-2x"
                                                               aria-hidden="true"
                                                               (click)="removeImage($event, 'pages', item, imageIndex)">
                                                            </i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-8">
                                                <textarea class="form-control caption-description-min-height"
                                                          name="featureImageCaption{{imageIndex}}"
                                                          resizable="false"
                                                          placeholder="Caption Text..."
                                                          [(ngModel)]="image.captionText"
                                                          maxlength="150">
                                                </textarea>
                                                    <span class="number-of-allowed-chars">
                                                    {{image.captionText.length}} / 150 Chars
                                                </span>
                                                    <textarea *ngIf="image.showDescription"
                                                              class="form-control caption-description-min-height m-t-sm"
                                                              name="featureImageDescription{{imageIndex}}"
                                                              resizable="false"
                                                              placeholder="Description Text..."
                                                              [(ngModel)]="image.descriptionText"
                                                              maxlength="65535">
                                                </textarea>
                                                    <div class="mtv-primary-color m-t-xs"
                                                         (click)="image.showDescription = !image.showDescription">
                                                        <span *ngIf="image.showDescription">- Hide</span>
                                                        <span *ngIf="!image.showDescription">+ Show</span>
                                                        Description
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="pageKey === websitePage.neighbourhood">
                                        <!--  What's Nearby   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4">
                                                <label>What's Nearby</label>
                                            </div>
                                            <div class="col-md-8">
                                            <textarea class="form-control"
                                                      name="whatIsNearby"
                                                      resizable="false"
                                                      [(ngModel)]="item.whatIsNearby"
                                                      maxlength="65535">
                                            </textarea>
                                            </div>
                                        </div>

                                        <!--  Street View   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="streetViewEnabled"
                                                           type="checkbox"
                                                           name="streetViewEnabled"
                                                           (ngModelChange)="toggleStreetView($event)"
                                                           [(ngModel)]="item.streetViewEnabled">
                                                    <label for="streetViewEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Street View</label>
                                            </div>
                                            <div class="col-md-5" style="padding-right: 0;">
                                                <input class="form-control"
                                                       name="mapAddress"
                                                       placeholder="Map Address"
                                                       [(ngModel)]="item.address">
                                            </div>
                                            <div class="col-md-3 btn-in-table">
                                                <button class="btn submit"
                                                        type="button"
                                                        (click)="getAddress(item.address, item)">
                                                    Check
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="pageKey === websitePage.contact">
                                        <!--  Company Name   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label>Company Name</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="companyName"
                                                       placeholder="Company name"
                                                       [(ngModel)]="item.companyName">
                                            </div>
                                        </div>

                                        <!--  Form Email   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="formEmailEnabled"
                                                           type="checkbox"
                                                           name="formEmailEnabled"
                                                           [(ngModel)]="item.formEmailEnabled">
                                                    <label for="formEmailEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Form Email</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="formEmail"
                                                       placeholder="Form Email"
                                                       [(ngModel)]="item.formEmail">
                                            </div>
                                        </div>
                                        <hr>
                                        <!--  Address   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="addressEnabled"
                                                           type="checkbox"
                                                           name="addressEnabled"
                                                           [(ngModel)]="item.addressEnabled">
                                                    <label for="addressEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Address</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="address"
                                                       placeholder="Address"
                                                       [(ngModel)]="item.address">
                                            </div>
                                        </div>


                                        <!--  Email   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="emailEnabled"
                                                           type="checkbox"
                                                           name="emailEnabled"
                                                           [(ngModel)]="item.emailEnabled">
                                                    <label for="emailEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Email</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="email"
                                                       placeholder="Enter Email "
                                                       [(ngModel)]="item.email">
                                            </div>
                                        </div>

                                        <!--  Phone   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="phoneEnabled"
                                                           type="checkbox"
                                                           name="phoneEnabled"
                                                           [(ngModel)]="item.phoneEnabled">
                                                    <label for="phoneEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Phone</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="phone"
                                                       placeholder="Enter Phone #"
                                                       [(ngModel)]="item.phone">
                                            </div>
                                        </div>

                                        <!--  Fax   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="faxEnabled"
                                                           type="checkbox"
                                                           name="faxEnabled"
                                                           [(ngModel)]="item.faxEnabled">
                                                    <label for="faxEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Fax</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="fax"
                                                       placeholder="Enter Fax #"
                                                       [(ngModel)]="item.fax">
                                            </div>
                                        </div>

                                        <!--  Office Hours   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5 padding-right-none">
                                                <label class="img-checkbox">
                                                    <input id="officeHoursEnabled"
                                                           type="checkbox"
                                                           name="officeHoursEnabled"
                                                           [(ngModel)]="item.officeHoursEnabled">
                                                    <label for="officeHoursEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Office Hours</label>
                                            </div>
                                            <div class="col-md-8">
                                                <div class="office-hours-input"
                                                     *ngFor="let hours of item.officeHours; let index = index; let last = last; trackBy: trackByFn;">
                                                    <input class="form-control"
                                                           [ngClass]="{'m-b-sm': !last}"
                                                           placeholder="Enter Office Hours"
                                                           [(ngModel)]="item.officeHours[index]"
                                                           [ngModelOptions]="{standalone: true}">
                                                    <i class="fa fa-trash pull-right visible-opacity"
                                                       *ngIf="item.officeHours.length > 1"
                                                       (click)="removeOfficeHoursRow(item.officeHours, index)"
                                                       data-toggle="tooltip" data-placement="top"
                                                       title="Delete">
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row m-b-sm">
                                            <div class="col-md-12">
                                                <i (click)="addOfficeHoursRow(item.officeHours)" data-toggle="tooltip"
                                                   class="fa icon-plus pull-right mtv-primary-color visible-opacity"
                                                   data-placement="top" title="Add"></i>
                                            </div>
                                        </div>
                                        <hr>
                                        <!--  Social LinkedIn   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="linkedInEnabled"
                                                           type="checkbox"
                                                           name="linkedInEnabled"
                                                           [(ngModel)]="item.social.linkedInEnabled">
                                                    <label for="linkedInEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>LinkedIn</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="linkedIn"
                                                       placeholder="LinkedIn"
                                                       [(ngModel)]="item.social.linkedIn">
                                            </div>
                                        </div>

                                        <!--  Social Facebook   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="facebookEnabled"
                                                           type="checkbox"
                                                           name="facebookEnabled"
                                                           [(ngModel)]="item.social.facebookEnabled">
                                                    <label for="facebookEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Facebook</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="facebook"
                                                       placeholder="Facebook"
                                                       [(ngModel)]="item.social.facebook">
                                            </div>
                                        </div>

                                        <!--  Social Twitter   -->
                                        <div class="row m-b-sm">
                                            <div class="col-md-4 p-t-5">
                                                <label class="img-checkbox">
                                                    <input id="twitterEnabled"
                                                           type="checkbox"
                                                           name="twitterEnabled"
                                                           [(ngModel)]="item.social.twitterEnabled">
                                                    <label for="twitterEnabled">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label>Twitter</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="form-control"
                                                       name="twitter"
                                                       placeholder="Twitter"
                                                       [(ngModel)]="item.social.twitter">
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="pageKey === websitePage.document">
                                        <div class="m-sm">
                                            <label>Documents</label>
                                            <div class="list-documents">
                                                <ul style="max-height:300px;overflow:auto;">
                                                    <ng-template #recursiveList let-list>
                                                        <li *ngFor="let item of list"
                                                            [class.show-folder]="item.showFolder">
                                                            <a *ngIf="item.type == 'file'"
                                                               class="item"
                                                               href="{{item.fileViewPath}}"
                                                               target="_blank">
                                                                <span class="doc-ext text-uppercase">{{item.ext}}</span>
                                                                <i class="doc-icon fa fa-file-o fa-file-{{item.ext}}-o"></i>
                                                                <span class="doc-title">{{item.name}}</span>
                                                            </a>
                                                            <ng-container
                                                                *ngIf="item.type == 'directory' && item.children.length > 0">
                                                                <a href="javascript:"
                                                                   class="item"
                                                                   (click)="item.showFolder = !item.showFolder">
                                                                    <i class="doc-icon fa fa-file-o fa-file-folder-o"></i>
                                                                    <span class="doc-title">{{item.name}}</span>
                                                                </a>
                                                                <ul>
                                                                    <ng-container
                                                                        *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children }">
                                                                    </ng-container>
                                                                </ul>
                                                            </ng-container>
                                                        </li>
                                                    </ng-template>
                                                    <ng-container
                                                        *ngTemplateOutlet="recursiveList; context:{ $implicit: websiteBuilderService.data.data.publicDocuments }">
                                                    </ng-container>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="pageKey === websitePage.announcements">
                                        <div class="m-sm">
                                            <label>Active Announcements ({{websiteBuilderService.data.data.announcements.length}})</label>
                                            <ul class="list-unstyled announcements-list">
                                                <li *ngFor="let notice of websiteBuilderService.data.data.announcements">
                                                    {{notice.title}}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div *ngIf="pageKey === websitePage.amenities">
                                        <div class="row m-b-sm">
                                            <div class="col-md-6">
                                                <label>Amenities to show</label>
                                            </div>
                                            <div class="col-md-6">
                                                <mat-radio-group name="amenitiesFilter"
                                                                 class="three-radio-buttons"
                                                                 (change)="amenityFilterToggle()"
                                                                 [(ngModel)]="amenitiesFilterEnabled">
                                                    <mat-radio-button [value]="false">
                                                        All
                                                    </mat-radio-button>
                                                    <mat-radio-button [value]="true">
                                                        Selected
                                                    </mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                        </div>

                                        <div *ngFor="let amenity of websiteBuilderService.data.data.publicAmenities" class="row m-b-sm">
                                            <div class="col-md-12">
                                                <label class="img-checkbox">
                                                    <input id="amenity_{{amenity.id}}"
                                                           type="checkbox"
                                                           name="amenity_{{amenity.id}}"
                                                           [disabled]="!amenitiesFilterEnabled"
                                                           (click)="onAmenityChange(amenity.id, $event)"
                                                           [checked]="isAmenityChecked(amenity.id)">
                                                    <label for="amenity_{{amenity.id}}">
                                                        <svg-checked></svg-checked>
                                                    </label>
                                                </label>
                                                <label for="amenity_{{amenity.id}}">{{amenity.name}} {{isAmenityChecked(amenity.id)|json}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div *ngIf="navPosition == 'publish'">
                    <div class="website-builder-slider-container m-b-sm settings-amenities-slider-container">
                        <span>Publish Website</span>
                        <mat-slide-toggle name="published" [(ngModel)]="websiteBuilderService.data.data.published">
                        </mat-slide-toggle>
                    </div>
                    <div class="m-b-md">
                        <label>Site Title</label>
                        <input type="text"
                               class="form-control"
                               name="websiteTitle"
                               [(ngModel)]="websiteBuilderService.data.data.websiteTitle">
                    </div>
                    <div class="website-domain-input m-b-md">
                        <div class="domain-input-part m-r-sm">
                            <input type="text"
                                   class="form-control"
                                   name="websiteName"
                                   [(ngModel)]="websiteBuilderService.data.data.websiteName">
                        </div>
                        <div class="maxcondoclub-com-part">.maxcondoclub.com</div>
                    </div>
                    <div class="two-buttons-row btn-in-table m-b-md row">
                        <div class="col-md-6">
                            <button class="btn submit" type="button" (click)="turnFullscreenModeOn()">
                                Preview In Fullscreen
                            </button>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-primary submit-btn"
                                    (click)="websiteBuilderService.sendData()"
                                    type="submit">Save
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/website-builder-side-editor.component.html